import { render, staticRenderFns } from "./CardTitleWrapper.vue?vue&type=template&id=74b07b42&scoped=true"
import script from "./CardTitleWrapper.vue?vue&type=script&lang=js"
export * from "./CardTitleWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b07b42",
  null
  
)

export default component.exports